import { useCallback } from 'react';

import { PasswordSet } from '../components/PasswordSet';
import { RootStackScreenProps } from '../../../app/UnauthenticatedApp/types';
import { useSetFirstPasswordMutation } from './__generated__/setFirstPassword.mutation.generated';

type Props = RootStackScreenProps<'SetFirstPassword'>;

export const SetFirstPassword = ({
	route: {
		params: { code, from },
	},
}: Props) => {
	const [setFirstPassword] = useSetFirstPasswordMutation();

	const handlePasswordChange = useCallback(
		async (newPassword: string) =>
			setFirstPassword({
				variables: {
					data: {
						code,
						newPassword,
					},
				},
			}),
		[code, setFirstPassword],
	);

	return <PasswordSet onSubmitPassword={handlePasswordChange} from={from} />;
};
